<template>
  <v-container fluid>
    <material-card
      icon="mdi-clipboard-text"
      inline
      title="Reports"
      color="darkblue"
    >
      <v-tabs v-model="moduleTab" height="60" color="primary">
        <v-tab
          v-for="item in Modal"
          @click="tabClickHandler(item.id)"
          :key="item.id"
        >
          {{ item.name }}
        </v-tab>
      </v-tabs>
      <v-divider class="my-0"></v-divider>
      <v-tabs-items v-model="moduleTab">
        <v-tab-item v-for="item in Modal" :key="item.id">
          <v-container fluid>
            <v-row>
              <v-col
                v-for="item1 in info"
                :key="item1.name"
                @click="getFilter(item1)"
                cols="12"
                sm="6"
                md="4"
                lg="3"
              >
                <v-hover v-slot="{ hover }">
                  <v-card
                    :elevation="hover ? 6 : 2"
                    :class="{ 'on-hover': hover }"
                    color="grey lighten-3"
                    class="pa-3 rounded-lg mt-7"
                  >
                    <div class="d-flex grow flex-wrap">
                      <v-sheet
                        :elevation="hover ? 6 : 2"
                        :class="{ 'on-hover': hover }"
                        :color="item1.color"
                        height="75"
                        weight="70"
                        width="auto"
                        class="text-start v-card--material__heading rounded-lg pa-5"
                        dark
                      >
                        <v-icon size="36"> {{ item1.icon }}</v-icon>
                      </v-sheet>
                      <div class="ml-2 text-left">
                        <div
                          class="font-weight-regular"
                          v-html="item1.name ? item1.name : ''"
                        ></div>
                      </div>
                    </div>
                  </v-card>
                  <!-- <v-card :elevation="hover ? 12 : 2" :class="{ 'on-hover': hover }">
                      <v-card-text>
<v-card-title>title</v-card-title>
                      </v-card-text>
                    </v-card> -->
                </v-hover>
                <!-- <material-card cardColor="grey lighten-3" color="primary" icon="mdi-google-classroom" :smalltitle="item1.name"> </material-card> -->
              </v-col>
            </v-row>
          </v-container>
        </v-tab-item>
        <template>
          <v-dialog  v-model="dialog" width="800">
            <v-card>
              <v-card-title
                class="headline primary lighten-2 white--text"
                v-html="chooseFilterHtml"
              >
              </v-card-title>
              <v-btn
                class="mt-8"
                color="error"
                elevation="1"
                x-small
                fab
                absolute
                top
                right
                type="button"
                @click="close()"
              >
                <v-icon>mdi-close</v-icon>
              </v-btn>
              <v-card-text>
                <v-container>
                  <v-row>
                    <v-col
                      cols="12"
                      md="6"
                      v-if="applyFilter && applyFilter.params.sourcetype"
                    >
                      <span class="body-2 font-weight-medium"
                        >Source Type<span class="error--text">*</span>
                      </span>
                      <v-autocomplete
                        v-model="selectedSourceTypeID"
                        class="my-0 py-1"
                        key="id"
                        item-value="name"
                        item-text="name"
                        :items="sourcetype"
                        placeholder="--Select SourceType--"
                        name="classSelect"
                        required
                      >
                      </v-autocomplete>
                    </v-col>
                    <v-col
                      cols="12"
                      md="6"
                      v-if="
                        applyFilter &&
                        applyFilter.params.sourceTypeEnquirySource
                      "
                    >
                      <span class="body-2 font-weight-medium"
                        >Source Type<span class="error--text">*</span>
                      </span>
                      <v-autocomplete
                        v-model="selectedSourceTypeEnquirySource"
                        class="my-0 py-1"
                        key="id"
                        item-value="name"
                        item-text="name"
                        :items="sourceTypeEnquirySource"
                        placeholder="--Select SourceType--"
                        name="classSelect"
                        required
                      >
                      </v-autocomplete>
                    </v-col>
                    <v-col
                      cols="12"
                      md="6"
                      v-if="applyFilter && applyFilter.params.franchisee"
                    >
                      <span class="body-2 font-weight-medium">
                        Franchisee <span class="error--text">*</span>
                      </span>
                      <div>
                        <b-checkbox v-model="flag" @input="allFranchisee"
                          >All Franchisee</b-checkbox
                        >
                      </div>
                      <multiselect
                        @remove="removeAllFlag"
                        class="overflowmultiselect2"
                        @input="getClassList(selectedFranchiseeID, applyFilter)"
                        label="companyName"
                        track-by="companyName"
                        :close-on-select="true"
                        :preserve-search="false"
                        :multiple="true"
                        :options="franchiseeArr"
                        v-model="selectedFranchiseeID"
                      >
                        <template
                          slot="selection"
                          slot-scope="{ values, isOpen }"
                          ><span
                            class="multiselect__single"
                            v-if="values.name &amp;&amp; !isOpen"
                            >{{ values.companyName }}
                          </span></template
                        >
                      </multiselect>

                      <!-- <v-autocomplete
                        v-model="selectedFranchiseeID"
                        class="my-0 py-1"
                        key="id"
                        item-value="id"
                        item-text="companyName"
                        :items="franchiseeArr"
                        @change="getClassList(selectedFranchiseeID, applyFilter)"
                        placeholder="--Select Franchisee--"
                        name="classSelect"
                        required
                      >
                      </v-autocomplete> -->
                    </v-col>
                    <!-- newly implimented --><v-col
                      cols="12"
                      md="6"
                      v-if="applyFilter && applyFilter.params.franchisee1"
                    >
                      <span class="body-2 font-weight-medium">
                        Franchisee <span class="error--text">*</span>
                      </span>
                      <!-- <div>
                        <b-checkbox v-model="flag" @input="allFranchisee"
                          >All Franchisee</b-checkbox
                        >
                      </div> -->
                      <multiselect
                        @remove="removeAllFlag"
                        class="overflowmultiselect2"
                        label="companyName"
                        track-by="companyName"
                        :close-on-select="true"
                        :preserve-search="false"
                        :multiple="true"
                        :options="franArray"
                        v-model="selectedFranchiseeID"
                        @open="checkFranchisee()"
                      >
                      <template
                          slot="selection"
                          slot-scope="{ values, isOpen }"
                          ><span
                            class="multiselect__single"
                            v-if="values.name &amp;&amp; !isOpen"
                            >{{ values.companyName }}
                          </span></template
                        >

                      </multiselect>

                      <!-- <v-autocomplete
                        v-model="selectedFranchiseeID"
                        class="my-0 py-1"
                        key="id"
                        item-value="id"
                        item-text="companyName"
                        :items="franchiseeArr"
                        @change="getClassList(selectedFranchiseeID, applyFilter)"
                        placeholder="--Select Franchisee--"
                        name="classSelect"
                        required
                      >
                      </v-autocomplete> -->
                    </v-col>

                    <!--  -->
                    <v-col
                      cols="12"
                      md="6"
                      v-if="applyFilter && applyFilter.params.nullfranchisee"
                    >
                      <span class="body-2 font-weight-medium">
                        Franchisee :<span class="error--text">*</span>
                      </span>
                      <div>
                        <b-checkbox v-model="flag" @input="allFranchisee"
                          >All Franchisee</b-checkbox
                        >
                      </div>
                      <multiselect
                        @remove="removeAllFlag"
                        class="overflowmultiselect2"
                        @input="
                          getClassList(selectedNullFranchiseeID, applyFilter)
                        "
                        label="companyName"
                        track-by="companyName"
                        :close-on-select="true"
                        :preserve-search="false"
                        :multiple="true"
                        :options="franchiseeArr1"
                        v-model="selectedNullFranchiseeID"
                      >
                        <template
                          slot="selection"
                          slot-scope="{ values, isOpen }"
                          ><span
                            class="multiselect__single"
                            v-if="values.name &amp;&amp; !isOpen"
                            >{{ values.companyName }}
                          </span></template
                        >
                      </multiselect>

                      <!-- <v-autocomplete
                        v-model="selectedFranchiseeID"
                        class="my-0 py-1"
                        key="id"
                        item-value="id"
                        item-text="companyName"
                        :items="franchiseeArr"
                        @change="getClassList(selectedFranchiseeID, applyFilter)"
                        placeholder="--Select Franchisee--"
                        name="classSelect"
                        required
                      >
                      </v-autocomplete> -->
                    </v-col>

                    <v-col
                      cols="12"
                      md="6"
                      v-if="applyFilter && applyFilter.params.zones"
                    >
                      <span class="body-2 font-weight-medium">
                        Zones<span class="error--text">*</span>
                      </span>
                      <div>
                        <b-checkbox v-model="zoneflag" @input="allZones"
                          >All Zones</b-checkbox
                        >
                      </div>
                      <multiselect
                        @remove="removeAllFlag"
                        class="overflowmultiselect2"
                        @input="
                          getselectedZonesList(selectedZoneID, applyFilter)
                        "
                        label="name"
                        track-by="name"
                        :close-on-select="true"
                        :preserve-search="false"
                        :multiple="true"
                        :options="zones"
                        v-model="selectedZoneID"
                      >
                        <template
                          slot="selection"
                          slot-scope="{ values, isOpen }"
                          ><span
                            class="multiselect__single"
                            v-if="values.name &amp;&amp; !isOpen"
                            >{{ values.name }}
                          </span></template
                        >
                      </multiselect>
                    </v-col>

                    <v-col
                      v-if="applyFilter && applyFilter.params.academicYear"
                      cols="12"
                      md="6"
                    >
                      <span class="body-2 font-weight-medium">
                        Academic Year <span class="error--text">*</span>
                      </span>
                      <v-autocomplete
                        class="my-0 py-1"
                        key="id"
                        v-model="academicYearID"
                        item-value="id"
                        :items="academicYears"
                        item-text="academicYear"
                        placeholder="--Select Year--"
                        name="classSelect"
                        required
                      >
                      </v-autocomplete>
                    </v-col>
                    <v-col
                      v-if="applyFilter && applyFilter.params.spanco"
                      cols="12"
                      md="6"
                    >
                      <span class="body-2 font-weight-medium">
                        Filter by Spanco <span class="error--text">*</span>
                      </span>
                      <v-autocomplete
                        class="my-0 py-1"
                        key="id"
                        v-model="spancoID"
                        item-value="id"
                        :items="spancoArray"
                        item-text="name"
                        placeholder="--Select--"
                        name="classSelect"
                        required
                      >
                      </v-autocomplete>
                    </v-col>
                    <v-col
                      v-if="applyFilter && applyFilter.params.class"
                      cols="12"
                      md="6"
                    >
                      <span class="body-2 font-weight-medium">
                        Class <span class="error--text">*</span>
                      </span>
                      <v-autocomplete
                        class="my-0 py-1"
                        key="id"
                        :items="classes"
                        v-model="selectedClassID"
                        @change="changeSections"
                        item-value="id"
                        item-text="name"
                        placeholder="--Select Class--"
                        name="classSelect"
                        required
                      >
                      </v-autocomplete>
                    </v-col>
                    <v-col
                      v-if="applyFilter && applyFilter.params.section"
                      cols="12"
                      md="6"
                    >
                      <span class="body-2 font-weight-medium">
                        Section <span class="error--text">*</span>
                      </span>
                      <v-autocomplete
                        class="my-0 py-1"
                        key="id"
                        item-value="id"
                        v-model="selectedSectionID"
                        item-text="name"
                        :items="classWiseSections"
                        placeholder="--Select Section--"
                        name="classSelect"
                        required
                      >
                      </v-autocomplete>
                    </v-col>
                    <v-col
                      v-if="applyFilter && applyFilter.params.feeTypeID"
                      cols="12"
                      md="6"
                    >
                      <span class="body-2 font-weight-medium">
                        Fee Type <span class="error--text">*</span>
                      </span>
                      <div>
                        <b-checkbox v-model="feeTypeFlag" @input="allFeeType"
                          >All Fee Type</b-checkbox
                        >
                      </div>
                      <!-- <v-autocomplete class="my-0 py-1" key="id" item-value="id"
                        v-model="selectedfeeTypeID" item-text="name" :items="feeTypeList"
                        placeholder="--Select Fee Type--" name="classSelect" required>
                      </v-autocomplete> -->
                      <multiselect
                        @remove="removeAllFlag"
                        class="overflowmultiselect2"
                        label="name"
                        track-by="name"
                        :close-on-select="true"
                        :preserve-search="false"
                        :multiple="true"
                        :options="feeTypeList"
                        v-model="selectedfeeTypeID"
                      >
                        <template
                          slot="selection"
                          slot-scope="{ values, isOpen }"
                          ><span
                            class="multiselect__single"
                            v-if="values.name &amp;&amp; !isOpen"
                            >{{ values.name }}
                          </span></template
                        >
                      </multiselect>
                    </v-col>
                    <v-col
                      v-if="
                        applyFilter && applyFilter.params.Offlinepaymentstatus
                      "
                      cols="12"
                      md="6"
                    >
                      <span class="body-2 font-weight-medium">
                        Select Offline Payment Status
                        <span class="error--text">*</span>
                      </span>
                      <v-autocomplete
                        class="my-1 py-0"
                        placeholder="--Select--"
                        v-model="selectedOfflineStatus"
                        menu-props="auto"
                        :items="PAYMENT_STATUS"
                        item-text="text"
                        item-value="value"
                      >
                      </v-autocomplete>
                    </v-col>
                    <v-col
                      cols="12"
                      md="6"
                      v-if="applyFilter && applyFilter.params.isExistingStudent"
                    >
                      <v-checkbox
                        v-model="selectedisExistingStudent"
                        label="Is Existing Student"
                      >
                      </v-checkbox>
                    </v-col>
                    <v-col
                      cols="12"
                      md="6"
                      v-if="applyFilter && applyFilter.params.isActive"
                    >
                      <v-checkbox
                        v-model="selectedisActive"
                        label="Is Active"
                      ></v-checkbox>
                    </v-col>
                    <v-col
                      v-if="applyFilter && applyFilter.params.fromDate"
                      cols="12"
                      md="6"
                    >
                      <span class="body-2 font-weight-medium">
                        From date <span class="error--text">{{ starTxt }}</span>
                      </span>
                      <custom-date-picker
                        :maxToDate="toDateFilter"
                        v-model.trim="fromDateFilter"
                      />
                    </v-col>
                    <v-col
                      v-if="applyFilter && applyFilter.params.toDate"
                      cols="12"
                      md="6"
                    >
                      <span class="body-2 font-weight-medium">
                        To Date <span class="error--text"> {{ starTxt }} </span>
                      </span>
                      <custom-date-picker
                        :minToDate="fromDateFilter"
                        v-model.trim="toDateFilter"
                      />
                    </v-col>
                  </v-row>
                </v-container>
              </v-card-text>
              <v-card min-height="50" flat></v-card>
              <v-divider class="my-0"></v-divider>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn
                  type="submit"
                  text
                  color="primary"
                  @click="applyFilerFun(applyFilter)"
                >
                  Export
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </template>
      </v-tabs-items>
    </material-card>
    <v-dialog v-model="dialogLoader" persistent width="300">
      <v-card color="primary" dark>
        <v-card-text>
          Please stand by
          <v-progress-linear
            indeterminate
            color="white"
            class="mb-0"
          ></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>
    <loading-icon :value="isLoading" />
  </v-container>
</template>
<script>
import { mapGetters } from 'vuex'
import MaterialCard from '@/components/template/MaterialCard'
import constants from '@/utils/constants'
import CustomDatePicker from '@/components/template/CustomDatePicker'
import Utils from '@/utils'
import Multiselect from 'vue-multiselect'
import _ from 'lodash'
import stores from '@/stores'
export default {
  components: { MaterialCard, CustomDatePicker, Multiselect },
  data () {
    return {
      flag: false,
      copyArray: {},
      selectedSourceTypeID: null,
      sourcetype: [],
      selectedSourceTypeEnquirySource: null,
      sourceTypeEnquirySource: [],
      modules: {
        Admission: this.checkModuleAccess('Admission'),
        Academics: this.checkModuleAccess('Academics'),
        Finance: this.checkModuleAccess('Finance'),
        Communication: this.checkModuleAccess('Communication'),
        Training: this.checkModuleAccess('Training'),
        CustomerCare: this.checkModuleAccess('CustomerCare'),
        Orders: this.checkModuleAccess('Orders')
      },
      moduleTab: null,
      selectedfeeTypeID: null,
      dialogLoader: false,
      selectedisExistingStudent: false,
      selectedisActive: false,
      selected_index: null,
      dialog: false,
      isLoading: false,
      moduleType: '',
      info: [],
      Modal: this.getModel(),
      infoModal: '',
      applyFilter: null,
      fromDateFilter: null,
      toDateFilter: null,
      selectedFranchiseeID: [],
      selectedNullFranchiseeID: [],
      selectedClassID: '',
      selectedSectionID: '',
      academicYearID: '',
      zoneID: '',
      zones: [],
      selectedZoneID: [],
      zoneflag: false,
      spancoID: '',
      franchiseeArr: [],
      classes: [],
      sections: [],
      academicYears: [],
      classWiseSections: [],
      PAYMENT_STATUS: [
        {
          text: 'INITIATED',
          value: 'INITIATED'
        },
        { text: 'FAILED', value: 'FAILED' },

        { text: 'APPROVAL_WAITING', value: 'APPROVAL_WAITING' },
        { text: 'TRANSFERRED', value: 'TRANSFERRED' },
        { text: 'REJECTED', value: 'REJECTED' },
        { text: 'ACCEPTED', value: 'ACCEPTED' }
      ],
      selectedOfflineStatus: null,
      chooseFilterHtml: '',
      starTxt: '*',
      spancoArray: [],
      franchiseeID: '',
      inProgress: false,
      franArray: [],
      feeTypeFlag: false,
      feeTypeList: [],
      zonesParam: false,
      kitIndentOrders: false
    }
  },
  async created () {
    this.getAcademicYear()
    let a = this.getModel()
    console.log('Modules---', a)
    this.tabClickHandler(this.Modal[0].id)
    this.paramsFilter()
  },
  computed: {
    ...mapGetters({
      franchisee: 'getFranchisee',
      academicYear: 'getAcademicYear'
    })
  },
  mounted: async function () {
    if (this.academicYear && this.academicYear.id) {
      await this.onFranchiseeChange()
    }
    if (this.franchisee.id) {
      await this.onFranchiseeChange()
    }
  },
  watch: {
    copyArray: function (val) {
      console.log('watcher ---', val)
    },
    academicYear: async function () {
      await this.onFranchiseeChange()
    },
    franchisee: async function (val) {
      await this.onFranchiseeChange()
    }
  },
  methods: {
    removeAllFlag: function () {
      this.flag = false
      this.feeTypeFlag = false
      this.zoneflag = false
      return true
    },
    tabClickHandler: function (item) {
      switch (item) {
        case 5:
          this.moduleType = 'Admission Module'
          this.info = [
            {
              id: 1,
              icon: 'mdi-feature-search',
              color: '#4caf50',
              name: 'Enquiry Report Details',
              api: '/reports/enquiry/enquiryreports',
              params: {
                franchisee: true,
                academicYear: true,
                toDate: true,
                fromDate: true,
                class: false,
                section: false,
                spanco: true
              }
            },
            {
              id: 1,
              icon: 'mdi-list-status',
              color: '#4caf50',
              name: 'Enquiry Stage Status',
              api: '/reports/enquiry/enquirystagestatusreport',
              params: {
                franchisee: true,
                academicYear: true,
                toDate: true,
                fromDate: true,
                class: false,
                section: false,
                spanco: true
              }
            },
            {
              id: 2,
              icon: 'mdi-briefcase-search',
              color: '#4caf50',
              name: 'Enquiry SourceWise',
              api: '/reports/enquiry/sourcewisereports',
              params: {
                franchisee: true,
                academicYear: true,
                toDate: true,
                fromDate: true,
                class: false,
                section: false,
                sourceTypeEnquirySource: true
              }
            },
            {
              id: 3,
              icon: 'mdi-cloud-search',
              color: '#4caf50',
              name: 'Classwise Performance',
              api: '/reports/enquiry/performanceclasswisereports',
              params: {
                franchisee: true,
                academicYear: true,
                toDate: false,
                fromDate: false,
                class: false,
                section: false
              }
            },
            // {
            //   id: 4,
            //   icon: 'mdi-account-multiple-check-outline',
            //   color: '#4caf50',
            //   name: 'Enquiry status',
            //   api: '/reports/enquiry/statusreports',
            //   params: {
            //     franchisee: true,
            //     academicYear: true,
            //     toDate: true,
            //     fromDate: true,
            //     class: false,
            //     section: false
            //   }
            // },
            {
              id: 5,
              icon: 'mdi-card-account-phone',
              color: '#4caf50',
              name: 'Enquiry Followup',
              api: '/reports/enquiry/followupreports',
              params: {
                franchisee: true,
                academicYear: true,
                toDate: true,
                fromDate: true,
                class: false,
                section: false
              }
            },
            {
              id: 6,
              icon: 'mdi-file-cancel',
              color: '#4caf50',
              name: 'Enquiry Cancelled',
              api: '/reports/enquiry/cancelledreports',
              params: {
                franchisee: true,
                academicYear: false,
                toDate: true,
                fromDate: true,
                class: false,
                section: false
              }
            },
            {
              id: 7,
              icon: 'mdi-notebook-check-outline',
              color: '#4caf50',
              name: 'Admitted Student ',
              api: '/reports/enquiry/admittedStudentListReport',
              params: {
                franchisee: true,
                academicYear: true,
                toDate: true,
                fromDate: true,
                class: false,
                section: false
              }
            },
            {
              id: 8,
              icon: 'mdi-cloud',
              color: '#4caf50',
              name: 'Assigned User <br/> Enquiry Report ',
              api: '/reports/enquiry/assignedUserEnquiryReport',
              params: {
                nullfranchisee: true,
                academicYear: true,
                toDate: true,
                fromDate: true,
                class: false,
                section: false
              }
            },
            {
              id: 9,
              icon: 'mdi-phone',
              color: '#4caf50',
              name: 'Call log report ',
              api: '/reports/callLogReport',
              params: {
                franchisee: true,
                academicYear: true,
                toDate: true,
                fromDate: true
              }
            }
          ]
          break
        case 6:
          this.moduleType = 'Academic Module'
          this.info = [
            {
              id: 1,
              icon: 'mdi-account-circle',
              color: 'warning',
              name: 'Student Details',
              api: '/reports/studentDetailsReport',
              params: {
                franchisee: true,
                academicYear: true,
                toDate: true,
                fromDate: true,
                class: false,
                section: false
              }
            },
            {
              id: 2,
              icon: 'mdi-clipboard-text',
              color: 'warning',
              name: 'Admission Details',
              api: '/reports/studentAdmissionReport',
              params: {
                franchisee: true,
                academicYear: true,
                toDate: true,
                fromDate: true,
                class: false,
                section: false
              }
            },
            {
              id: 3,
              icon: 'mdi-account-tie',
              color: 'warning',
              name: 'Alumini Student Details',
              api: '/reports/aluminiStudentDetailsReport',
              params: {
                franchisee: true,
                academicYear: false,
                toDate: true,
                fromDate: true,
                class: false,
                section: false
              }
            },
            {
              id: 4,
              icon: 'mdi-human-female',
              color: 'warning',
              name: 'Class Teacher',
              api: '/reports/classTeacherReport',
              params: {
                franchisee: true,
                academicYear: true,
                toDate: true,
                fromDate: true,
                class: false,
                section: false
              }
            },
            {
              id: 5,
              icon: 'mdi-account-remove',
              color: 'warning',
              name: 'Inactive Student List',
              api: '/reports/inactiveStudentListReport',
              params: {
                franchisee: true,
                academicYear: true,
                toDate: true,
                fromDate: true,
                class: false,
                section: false
              }
            },
            {
              id: 6,
              icon: 'mdi-account-remove-outline',
              color: 'warning',
              name: 'Inactive Student',
              api: '/reports/inactiveStudentReport',
              params: {
                franchisee: true,
                academicYear: true,
                toDate: true,
                fromDate: true,
                class: false,
                section: false
              }
            },
            {
              id: 7,
              icon: 'mdi-card-account-details',
              color: 'warning',
              name: 'Staff Details',
              api: '/reports/staffDetailsReport',
              params: {
                franchisee: true,
                academicYear: false,
                toDate: true,
                fromDate: true,
                class: false,
                section: false
              }
            },
            {
              id: 8,
              icon: 'mdi-account-multiple',
              color: 'warning',
              name: 'Staff Dashboard',
              api: '/reports/staffDashboardReport',
              params: {
                franchisee: true,
                academicYear: false,
                toDate: false,
                fromDate: false,
                class: false,
                section: false
              }
            },
            {
              id: 9,
              icon: 'mdi-card-account-details-outline',
              color: 'warning',
              name: 'All Franchise Attendance',
              api: '/reports/studentAttendenceReport',
              params: {
                franchisee: true,
                academicYear: true,
                toDate: true,
                fromDate: true,
                class: false,
                section: false
              }
            },
            {
              id: 10,
              icon: 'mdi-account',
              color: 'warning',
              name: 'Student Promoted',
              api: '/reports/studentPromotedReport',
              params: {
                franchisee: true,
                academicYear: true,
                toDate: false,
                fromDate: false,
                class: false,
                section: false
              }
            },
            {
              id: 11,
              icon: 'mdi-account-group',
              color: 'warning',
              name: 'Student Strenght',
              api: '/reports/studentStrenghtReport',
              params: {
                franchisee: true,
                academicYear: true,
                toDate: false,
                fromDate: false,
                class: false,
                section: false
              }
            },
            {
              id: 12,
              icon: 'mdi-account-tie',
              color: 'warning',
              name: 'Student Wise Attendence',
              api: '/reports/studentWiseReport',
              params: {
                franchisee1: true,
                academicYear: true,
                toDate: true,
                fromDate: true,
                class: false,
                section: false
              }
            }
          ]

          break
        case 7:
          this.moduleType = 'Finance Module'
          this.info = [
            {
              id: 1,
              icon: 'mdi-currency-inr',
              color: 'green',
              name: 'Class Fee Structure',
              api: '/report/financereport/classfeestructure',
              params: {
                franchisee: true,
                academicYear: true,
                toDate: false,
                fromDate: false,
                class: true,
                section: false,
                isExistingStudent: false,
                isActive: false,
                feeTypeID: false
              }
            },
            {
              id: 2,
              icon: 'mdi-cash-check',
              color: 'green',
              name: 'Offline Payment',
              api: '/report/financereport/offlinepaymentreport',
              params: {
                franchisee: true,
                academicYear: true,
                toDate: true,
                fromDate: true,
                class: false,
                section: false,
                isExistingStudent: false,
                isActive: false,
                feeTypeID: false,
                Offlinepaymentstatus: false
              }
            },
            {
              id: 3,
              icon: 'mdi-cash-lock-open',
              color: 'green',
              name: 'Cancelled Fee',
              api: '/report/financereport/cancelledFee',
              params: {
                franchisee: true,
                academicYear: true,
                toDate: true,
                fromDate: true,
                class: false,
                section: false,
                isExistingStudent: false,
                isActive: false,
                feeTypeID: false,
                Offlinepaymentstatus: false
              }
            },
            {
              id: 4,
              icon: 'mdi-card-account-details-star-outline',
              color: 'green',
              name: 'Concession Fee Detail',
              api: '/report/financereport/concessiondetails',
              params: {
                franchisee: true,
                academicYear: true,
                toDate: true,
                fromDate: true,
                class: false,
                section: false,
                isExistingStudent: false,
                isActive: false,
                feeTypeID: false,
                Offlinepaymentstatus: false
              }
            },
            {
              id: 5,
              icon: 'mdi-layers',
              color: 'green',
              name: 'Service Royalty Report',
              api: '/report/financereport/serviceroyaltyreport',
              params: {
                franchisee: true,
                academicYear: true,
                toDate: true,
                fromDate: true,
                class: false,
                section: false,
                isExistingStudent: false,
                isActive: false,
                feeTypeID: false,
                Offlinepaymentstatus: false
              }
            },
            /* {
              id: 5,
              icon: 'mdi-cash-lock',
              color: 'green',
              name: 'Fee Componant Change',
              api: '/report/financereport/feecomponentchanges',
              params: {
                franchisee: true,
                academicYear: true,
                toDate: true,
                fromDate: true,
                class: false,
                section: false,
                isExistingStudent: false,
                isActive: false,
                feeTypeID: false,
                Offlinepaymentstatus: false
              }
            }, */
            {
              id: 6,
              icon: 'mdi-notebook',
              color: 'green',
              name: 'Fee Plan Details',
              api: '/report/financereport/feeplandetails',
              params: {
                franchisee: true,
                academicYear: true,
                toDate: false,
                fromDate: false,
                class: true,
                section: false,
                isExistingStudent: false,
                isActive: false,
                feeTypeID: false,
                Offlinepaymentstatus: false
              }
            },
            {
              id: 7,
              icon: 'mdi-clipboard-edit',
              color: 'green',
              name: 'Last Year Due Details',
              api: '/report/financereport/lastyeardue',
              params: {
                franchisee: true,
                academicYear: true,
                toDate: false,
                fromDate: false,
                class: false,
                section: false,
                isExistingStudent: false,
                isActive: false,
                feeTypeID: false,
                Offlinepaymentstatus: false
              }
            },
            {
              id: 8,
              icon: 'mdi-clipboard-edit-outline',
              color: 'green',
              name: 'Total Paid Due Details',
              api: '/report/financereport/totalpaiddue',
              params: {
                franchisee: true,
                academicYear: true,
                toDate: true,
                fromDate: true,
                class: false,
                section: false,
                isExistingStudent: false,
                isActive: true,
                feeTypeID: true,
                Offlinepaymentstatus: false
              }
            },
            {
              id: 9,
              icon: 'mdi-text-box-check',
              color: 'green',
              name: 'Receipt Details',
              api: '/report/financereport/receiptdetails',
              params: {
                franchisee: true,
                academicYear: true,
                toDate: true,
                fromDate: true,
                class: false,
                section: false,
                isExistingStudent: false,
                isActive: false,
                feeTypeID: false,
                Offlinepaymentstatus: false
              }
            },
            // {
            //   id: 10,
            //   icon: 'mdi-receipt',
            //   color: 'green',
            //   name: 'Franchisee to Brainbees <br/> Receipt Details',
            //   api: '/report/financereport/brainbeesreceiptdetails',
            //   params: {
            //     franchisee: true,
            //     academicYear: true,
            //     toDate: true,
            //     fromDate: true,
            //     class: false,
            //     section: false,
            //     isExistingStudent: false,
            //     isActive: false,
            //     feeTypeID: false,
            //     Offlinepaymentstatus: false
            //   }
            // },
            {
              id: 10,
              icon: 'mdi-checkbox-multiple-blank-circle',
              color: 'green',
              name: 'Nodal Report',
              api: '/report/financereport/noddlereportdetails',
              params: {
                franchisee: true,
                academicYear: true,
                toDate: true,
                fromDate: true,
                class: false,
                section: false,
                isExistingStudent: false,
                isActive: false,
                feeTypeID: false,
                Offlinepaymentstatus: false
              }
            },
            {
              id: 11,
              icon: 'mdi-layers',
              color: 'green',
              name: 'Royalty Report',
              api: '/report/financereport/royaltyreport',
              params: {
                franchisee: true,
                academicYear: true,
                toDate: true,
                fromDate: true,
                class: false,
                section: false,
                isExistingStudent: false,
                isActive: false,
                feeTypeID: false,
                Offlinepaymentstatus: false
              }
            },
            {
              id: 11,
              icon: 'mdi-receipt',
              color: 'green',
              name: 'Payment Receipt Details',
              api: '/report/financereport/paymentreceiptdetails',
              params: {
                franchisee: true,
                academicYear: true,
                toDate: true,
                fromDate: true,
                class: false,
                section: false,
                isExistingStudent: false,
                isActive: false,
                feeTypeID: false,
                Offlinepaymentstatus: false
              }
            },
            {
              id: 12,
              icon: 'mdi-human-edit',
              color: 'green',
              name: 'Ledger Report',
              api: '/report/financereport/leager-report',
              params: {
                franchisee: true,
                academicYear: false,
                toDate: true,
                fromDate: true,
                class: false,
                section: false,
                isExistingStudent: false,
                isActive: false,
                feeTypeID: false,
                Offlinepaymentstatus: false
              }
            },
            {
              id: 13,
              icon: 'mdi-book-check',
              color: 'green',
              name: 'kit Paid Vs Due',
              api: '/report/financereport/kit-paid-vs-due',
              params: {
                franchisee: true,
                academicYear: true,
                toDate: true,
                fromDate: true,
                class: false,
                section: false,
                isExistingStudent: false,
                isActive: false,
                feeTypeID: false,
                Offlinepaymentstatus: false
              }
            },
            {
              id: 14,
              icon: 'mdi-account-details',
              color: 'green',
              name: 'Recipient Details',
              api: '/report/financereport/recipient-details',
              params: {
                franchisee: true,
                academicYear: true,
                toDate: true,
                fromDate: true
              }
            },
            {
              id: 15,
              icon: 'mdi-account-details',
              color: 'green',
              name: 'Franchisee Master',
              api: '/report/financereport/finance-master',
              params: {
                academicYear: true,
                isActive: true,
                isFranchiseeMaster: true
              }
            }
          ]
          break
        case 8:
          this.moduleType = 'communication Module'
          this.info = [
            {
              id: 1,
              icon: 'mdi-speaker',
              color: 'rgb(93, 88, 239)',
              name: 'Announcement Details',
              api: '/reports/announcementReport',
              params: {
                franchisee: true,
                academicYear: false,
                toDate: true,
                fromDate: true,
                class: false,
                section: false,
                isExistingStudent: false,
                isActive: false,
                feeTypeID: false,
                Offlinepaymentstatus: false
              }
            },
            {
              id: 2,
              icon: 'mdi-message-reply-text',
              color: 'rgb(93, 88, 239)',
              name: 'SMS Log Report',
              api: '/reports/smsLogReport',
              params: {
                franchisee: true,
                academicYear: false,
                toDate: true,
                fromDate: true,
                class: false,
                section: false,
                isExistingStudent: false,
                isActive: false,
                feeTypeID: false,
                Offlinepaymentstatus: false
              }
            },
            {
              id: 3,
              icon: 'mdi-email-multiple',
              color: 'rgb(93, 88, 239)',
              name: 'Email Log Report',
              api: '/reports/emailLogReport',
              params: {
                franchisee: true,
                academicYear: false,
                toDate: true,
                fromDate: true,
                class: false,
                section: false,
                isExistingStudent: false,
                isActive: false,
                feeTypeID: false,
                Offlinepaymentstatus: false
              }
            },
            {
              id: 4,
              icon: 'mdi-text-box-plus',
              color: 'rgb(93, 88, 239)',
              name: 'Subject Diary Details ',
              api: '/reports/subjectDairyDetailsReport',
              params: {
                franchisee: true,
                academicYear: true,
                toDate: true,
                fromDate: true,
                class: true,
                section: true,
                isExistingStudent: false,
                isActive: false,
                feeTypeID: false,
                Offlinepaymentstatus: false
              }
            },
            {
              id: 5,
              icon: 'mdi-text-box-check',
              color: 'rgb(93, 88, 239)',
              name: 'Subject Diary Summary',
              api: '/reports/subjectDairySummaryReport',
              params: {
                franchisee: true,
                academicYear: true,
                toDate: true,
                fromDate: true,
                class: true,
                section: true,
                isExistingStudent: false,
                isActive: false,
                feeTypeID: false,
                Offlinepaymentstatus: false
              }
            },
            {
              id: 6,
              icon: 'mdi-text-box-multiple-outline',
              color: 'rgb(93, 88, 239)',
              name: 'General Diary Details',
              api: '/reports/generalDairyDetailsReport',
              params: {
                franchisee: true,
                academicYear: true,
                toDate: true,
                fromDate: true,
                class: true,
                section: true,
                isExistingStudent: false,
                isActive: false,
                feeTypeID: false,
                Offlinepaymentstatus: false
              }
            }
          ]
          break
        case 9:
          this.moduleType = 'Training Module'
          this.info = [
            {
              id: 1,
              icon: 'mdi-newspaper-plus',
              color: '#EA4C89',
              name: 'Teacher Assessment',
              api: '/reports/v1/teacherassessment',
              params: {
                zones: true,
                franchisee: false,
                academicYear: true,
                toDate: false,
                fromDate: false,
                class: false,
                section: false
              }
            },
            {
              id: 2,
              icon: 'mdi-teach',
              color: '#EA4C89',
              name: 'Teacher Training',
              api: '/reports/v1/teachertraining',
              params: {
                franchisee: false,
                zones: true,
                academicYear: true,
                toDate: false,
                fromDate: false,
                class: false,
                section: false,
                sourcetype: false
              }
            },
            {
              id: 3,
              icon: 'mdi-notebook-multiple',
              color: '#EA4C89',
              name: 'Teacher Diary',
              api: '/reports/teacherdairy',
              params: {
                franchisee: true,
                academicYear: true,
                toDate: false,
                fromDate: false,
                class: false,
                section: false
              }
            },
            {
              id: 4,
              icon: 'mdi-account-check',
              color: '#EA4C89',
              name: 'Training Assigned',
              api: '/reports/trainingassigned',
              params: {
                franchisee: true,
                academicYear: false,
                toDate: true,
                fromDate: true,
                class: true,
                section: false
              }
            },
            {
              id: 5,
              icon: 'mdi-calendar-month',
              color: '#EA4C89',
              name: 'Training Calendar',
              api: '/reports/trainingcalendar',
              params: {
                franchisee: true,
                academicYear: false,
                toDate: true,
                fromDate: true,
                class: false,
                section: false
              }
            }
          ]
          break
        case 10:
          this.moduleType = 'CustomerCare'
          this.info = [
            {
              id: 1,
              icon: 'mdi-card-account-phone',
              color: 'warning',
              name: 'Yet to Call lead',
              api: '/reports/yet-to-call-lead-report',
              params: {
                franchisee: false,
                academicYear: true,
                toDate: false,
                fromDate: true,
                class: false,
                section: false
              }
            },
            {
              id: 2,
              icon: 'mdi-phone',
              color: 'warning',
              name: 'Called but No Response',
              api: '/reports/called-but-no-response',
              params: {
                franchisee: false,
                academicYear: true,
                toDate: true,
                fromDate: true,
                class: false,
                section: false,
                sourcetype: false
              }
            },
            {
              id: 3,
              icon: 'mdi-account-cash',
              color: 'warning',
              name: 'Not Confirmed Student Payment Details',
              api: '/reports/not-confirmed-student-payment-details',
              params: {
                franchisee: false,
                academicYear: true,
                toDate: true,
                fromDate: true,
                class: false,
                section: false
              }
            },
            {
              id: 4,
              icon: 'mdi-file-phone-outline',
              color: 'warning',
              name: 'For Call Log Details',
              api: '/reports/call-log-details',
              params: {
                franchisee: false,
                academicYear: true,
                toDate: true,
                fromDate: true,
                class: false,
                section: false
              }
            },
            {
              id: 5,
              icon: 'mdi-file-check',
              color: 'warning',
              name: 'Follow Up Cases',
              api: '/reports/follow-up-cases',
              params: {
                franchisee: false,
                academicYear: true,
                toDate: true,
                fromDate: true,
                class: false,
                section: false
              }
            },
            {
              id: 6,
              icon: 'mdi-water-percent',
              color: 'warning',
              name: 'Conversion Percentage Funnel',
              api: '/reports/conversion-percentage-funnel',
              params: {
                franchisee: false,
                academicYear: true,
                toDate: true,
                fromDate: true,
                class: false,
                section: false
              }
            },
            {
              id: 7,
              icon: 'mdi-salesforce',
              color: 'warning',
              name: 'Online Sales Payment Closure Summary',
              api: '/reports/online-sales',
              params: {
                franchisee: false,
                academicYear: true,
                class: false,
                section: false
              }
            },
            {
              id: 7,
              icon: 'mdi-card-account-details-outline',
              color: 'warning',
              name: 'Daily Agent Performance Report',
              api: '/reports/daily-agent-performance',
              params: {
                franchisee: false,
                academicYear: true,
                toDate: true,
                fromDate: true,
                class: false,
                section: false
              }
            }
            // {
            //   id: 5,
            //   icon: 'mdi-phone-log-outline',
            //   color: 'warning',
            //   name: 'Hourly dialling report agentwise',
            //   api: '/reports/CallLogDetails',
            //   params: {
            //     franchisee: true,
            //     academicYear: true,
            //     toDate: true,
            //     fromDate: true,
            //     class: false,
            //     section: false
            //   }
            // },
            // {
            //   id: 6,
            //   icon: 'mdi-cash-refund',
            //   color: 'warning',
            //   name: 'Lead & Payment Details Report:',
            //   api: '/reports/CallLogDetails',
            //   params: {
            //     franchisee: true,
            //     academicYear: true,
            //     toDate: true,
            //     fromDate: true,
            //     class: false,
            //     section: false
            //   }
            // },
            // {
            //   id: 8,
            //   icon: 'mdi-cash-lock',
            //   color: 'warning',
            //   name: 'Payment closure summary',
            //   api: '/reports/CallLogDetails',
            //   params: {
            //     franchisee: true,
            //     academicYear: true,
            //     toDate: true,
            //     fromDate: true,
            //     class: false,
            //     section: false
            //   }
            // }
          ]
          break
        case 11:
          this.moduleType = 'Orders'
          this.info = [
            {
              id: 1,
              icon: 'mdi-receipt',
              color: 'green',
              name: 'B2B Order Details',
              api: '/report/ordersreport/b2b-order',
              params: {
                franchisee: true,
                toDate: true,
                fromDate: true
              }
            },
            {
              id: 2,
              icon: 'mdi-receipt',
              color: 'green',
              name: 'Order Purchase Details',
              api: '/report/ordersreport/order-purchase',
              params: {
                franchisee: true,
                toDate: true,
                fromDate: true
              }
            },
            {
              id: 3,
              icon: 'mdi-briefcase',
              color: 'green',
              name: 'AY19-20 Ledger Details',
              api: '/report/ordersreport/ledger',
              params: {
                franchisee: true,
                toDate: true,
                fromDate: true
              }
            },
            {
              id: 4,
              icon: 'mdi-cart-outline',
              color: 'green',
              name: 'Order Details',
              api: '/report/ordersreport/order',
              params: {
                franchisee: true,
                toDate: true,
                fromDate: true
              }
            },
            {
              id: 5,
              icon: 'mdi-account-settings',
              color: 'green',
              name: 'Lead Source',
              api: '/report/ordersreport/lead-source',
              params: {
                toDate: true,
                fromDate: true
              }
            },
            {
              id: 6,
              icon: 'mdi-cash-multiple',
              color: 'green',
              name: 'Student Concession',
              api: '/report/ordersreport/student-concession',
              params: {
                franchisee: true,
                toDate: true,
                fromDate: true
              }
            },
            {
              id: 7,
              icon: 'mdi-currency-usd',
              color: 'green',
              name: 'Order Shipping Details',
              api: '/report/ordersreport/order-shipping-details',
              params: {
                franchisee: true,
                toDate: true,
                fromDate: true
              }
            },
            {
              id: 7,
              icon: 'mdi-currency-usd',
              color: 'green',
              name: 'AY19_20 Royalty Report',
              api: '/report/ordersreport/royalty',
              params: {
                franchisee: true,
                toDate: true,
                fromDate: true
              }
            },
            {
              id: 7,
              icon: 'mdi-currency-usd',
              color: 'green',
              name: 'Statuswise Order Tat',
              api: '/report/ordersreport/statuswise-order-tat',
              params: {
                franchisee: false,
                toDate: false,
                fromDate: false
              }
            },
            {
              id: 7,
              icon: 'mdi-currency-usd',
              color: 'green',
              name: 'Citywise Order Tat',
              api: '/report/ordersreport/citywise-order-tat',
              params: {
                franchisee: false,
                toDate: false,
                fromDate: false
              }
            },
            {
              id: 7,
              icon: 'mdi-currency-usd',
              color: 'green',
              name: 'Damaged Kit Ops',
              api: '/report/ordersreport/damaged-kit-ops',
              params: {
                franchisee: true,
                academicYear: true
              }
            },
            {
              id: 7,
              icon: 'mdi-currency-usd',
              color: 'green',
              name: 'Kit Indent Report',
              api: '/report/ordersreport/kit-indent-report',
              params: {
                franchisee: true,
                academicYear: true,
                zones: this.zonesParam
              }
            }
          ]
          if (!this.kitIndentOrders) {
            this.info = this.info.filter(item => item.name !== 'Kit Indent Report')
          }
      }

      return this.info
    },
    getModel: function () {
      let module1 = []
      if (this.modules && this.modules.Admission) {
        module1.push({ id: 5, name: 'Admission' })
        this.moduleTab = 'Admission'
      }
      if (this.modules && this.modules.Academics) {
        module1.push({ id: 6, name: 'Academics' })
        this.moduleTab = 'Academics'
      }
      if (this.modules && this.modules.Finance) {
        module1.push({ id: 7, name: 'Finance' })
        this.moduleTab = 'Finance'
      }
      if (this.modules && this.modules.Communication) {
        module1.push({ id: 8, name: 'Communication' })
        this.moduleTab = 'Communication'
      }
      if (this.modules && this.modules.Training) {
        module1.push({ id: 9, name: 'Training' })
        this.moduleTab = 'Training'
      }
      if (this.modules && this.modules.CustomerCare) {
        module1.push({ id: 10, name: 'Customer Care' })
        this.moduleTab = 'CustomerCare'
      }
      if (this.modules && this.modules.Orders) {
        module1.push({ id: 11, name: 'Orders' })
        this.moduleTab = 'Orders'
      }

      this.Modal = module1
      return module1
    },
    checkModuleAccess: function (moduleName) {
      return Utils.helper.checkAccessByModule(this.$route, moduleName)
    },

    applyFilerFun: async function (item) {
      try {
        let parameters = {}
        if (item.params.sourcetype) {
          if (this.selectedSourceTypeID === null) {
            return this.$dialog.error({
              text: ` Source Type cannot be blank`,
              title: 'Error'
            })
          } else {
            parameters.sourceType = this.selectedSourceTypeID
          }
        }
        if (item.params.sourceTypeEnquirySource) {
          if (this.selectedSourceTypeEnquirySource === null) {
            return this.$dialog.error({
              text: ` Source Type cannot be blank`,
              title: 'Error'
            })
          } else {
            parameters.sourceType = this.selectedSourceTypeEnquirySource
          }
        }
        if (item.params.franchisee) {
          if (_.isEmpty(this.selectedFranchiseeID)) {
            return this.$dialog.error({
              text: ` Franchisee cannot be blank`,
              title: 'Error'
            })
          } else {
            console.log(
              _.map(this.selectedFranchiseeID, 'id'),
              'this.selectedFranchiseeID'
            )
            parameters.franchiseeID = _.map(
              this.selectedFranchiseeID,
              'id'
            ).join(',')
          }
        }
        if (item.params.franchisee1) {
          if (_.isEmpty(this.selectedFranchiseeID)) {
            return this.$dialog.error({
              text: ` Franchisee cannot be blank`,
              title: 'Error'
            })
          } else {
            console.log(
              _.map(this.selectedFranchiseeID, 'id'),
              'this.selectedFranchiseeID'
            )
            parameters.franchiseeID = _.map(
              this.selectedFranchiseeID,
              'id'
            ).join(',')
          }
        }
        if (item.params.nullfranchisee) {
          if (_.isEmpty(this.selectedNullFranchiseeID)) {
            return this.$dialog.error({
              text: ` Franchisee cannot be blank`,
              title: 'Error'
            })
          } else {
            console.log(
              _.map(this.selectedNullFranchiseeID, 'id'),
              'this.selectedNullFranchiseeID'
            )
            parameters.nullfranchiseeID = _.map(
              this.selectedNullFranchiseeID,
              'id'
            ).join(',')
          }
        }

        if (item.params.zones) {
          if (_.isEmpty(this.selectedZoneID)) {
            return this.$dialog.error({
              text: ` Zone cannot be blank`,
              title: 'Error'
            })
          } else {
            console.log(
              _.map(this.selectedZoneID, 'id'),
              'this.selectedZoneID'
            )
            parameters.zoneID = _.map(
              this.selectedZoneID,
              'id'
            ).join(',')
          }
        }

        if (
          item &&
          item.params.academicYear &&
          !item.params.isFranchiseeMaster
        ) {
          if (this.academicYearID === '') {
            return this.$dialog.error({
              text: ` Acadamic Year cannot be blank`,
              title: 'Error'
            })
          } else {
            parameters.academicYearID = this.academicYearID
          }
        } else if (this.academicYearID !== '') {
          parameters.academicYearID = this.academicYearID
        }
        if (item && item.params.spanco) {
          if (this.spancoID === '') {
            return this.$dialog.error({
              text: `Spanco cannot be blank`,
              title: 'Error'
            })
          } else {
            parameters.spancoID = this.spancoID
          }
        }
        let toDateFlag = false
        if (
          item.name === 'Student Details' ||
          item.name === 'Admission Details' ||
          item.name === 'Enquiry Stage Status' ||
          item.name === 'Enquiry Report Details'
        ) {
          toDateFlag = true
        }
        if (this.fromDateFilter !== null && this.toDateFilter === null) {
          toDateFlag = false
        }
        if (this.toDateFilter !== null && this.fromDateFilter === null) {
          toDateFlag = false
        }
        if (item.params.toDate) {
          if (this.toDateFilter === null && !toDateFlag) {
            return this.$dialog.error({
              text: ` To DATE cannot be blank`,
              title: 'Error'
            })
          } else {
            parameters.toDate = this.toDateFilter
          }
        }
        if (item.params.fromDate) {
          if (this.fromDateFilter === null && !toDateFlag) {
            return this.$dialog.error({
              text: ` From DATE cannot be blank`,
              title: 'Error'
            })
          } else {
            parameters.fromDate = this.fromDateFilter
          }
        }
        if (item.params.class) {
          if (this.selectedClassID === '') {
            return this.$dialog.error({
              text: ` Class cannot be blank`,
              title: 'Error'
            })
          } else {
            parameters.classID = this.selectedClassID
          }
        }
        if (item.params.section) {
          if (this.selectedSectionID === '') {
            return this.$dialog.error({
              text: ` Section cannot be blank`,
              title: 'Error'
            })
          } else {
            parameters.sectionid = this.selectedSectionID
          }
        }
        if (item.params.feeTypeID) {
          if (this.selectedfeeTypeID === '') {
            return this.$dialog.error({
              text: ` Fee Type cannot be blank`,
              title: 'Error'
            })
          } else {
            parameters.feeTypeID = _.map(this.selectedfeeTypeID, 'id').join(',')
          }
        }

        if (item.params.isExistingStudent) {
          parameters.isExistingStudent = this.selectedisExistingStudent
        }
        if (item.params.isActive) {
          parameters.isActive = this.selectedisActive
        }
        if (item.params.Offlinepaymentstatus) {
          if (this.selectedOfflineStatus === '') {
            return this.$dialog.error({
              text: ` Offline status cannot be blank`,
              title: 'Error'
            })
          } else {
            parameters.Offlinepaymentstatus = this.selectedOfflineStatus
          }
        }
        this.dialogLoader = true
        await http.get(`${constants.API_URL}/api${item.api}`, {
          params: parameters
        })

        this.dialog = false
        await this.$router.push({ name: 'B2SReportDownload' })
      } catch (e) {
        const errorMessage =
          (e && e.response && e.response.data.message) || e.message
        console.log('errorMessage', errorMessage)
        return this.$dialog.error({
          text: ` ${errorMessage}`,
          title: 'Error'
        })
      } finally {
        this.dialogLoader = false
      }
    },
    getFilter: async function (item) {
      this.copyArray = JSON.parse(JSON.stringify(item))
      this.dialogLoader = true
      this.chooseFilterHtml = 'Choose Filter'
      this.starTxt = '*'
      if (
        item.name === 'Student Details' ||
        item.name === 'Admission Details' ||
        item.name === 'Enquiry Stage Status' ||
        item.name === 'Enquiry Report Details'
      ) {
        this.starTxt = ''
      }
      if (item.params.franchisee) {
        this.selectedFranchiseeID = ''
        this.franchiseeArr = []
        this.flag = false
        await this.getFranchiseeList()
      }
      if (item.params.franchisee1) {
        this.selectedFranchiseeID = ''
        this.franchiseeArr = []
        this.flag = false
      }
      if (item.params.nullfranchisee) {
        this.selectedNullFranchiseeID = ''
        this.franchiseeArr1 = []
        this.flag = false
        await this.getFranchiseeList1()
      }
      if (item && item.params.academicYear) {
        this.academicYearID = ''
        this.academicYears = []
        await this.getAcademicYear()
      }
      if (item && item.params.zones) {
        this.zoneID = ''
        this.zones = []
        this.zoneflag = false
        await this.getZoneDetails()
      }
      if (item && item.params.spanco) {
        this.spancoID = ''
        this.spancoArray = []
        await this.filterBySpanco()
      }
      if (item.params.toDate) {
        this.toDateFilter = null
      }
      if (item.params.sourcetype) {
        this.sourcetype = []
        this.selectedSourceTypeID = null
        await this.getSourceType()
      }
      if (item.params.sourceTypeEnquirySource) {
        this.sourceTypeEnquirySource = []
        this.selectedSourceTypeID = null
        await this.getSourceTypeForEnquirySource()
      }
      if (item.params.fromDate) {
        this.fromDateFilter = null
      }
      if (item.params.class) {
        this.selectedClassID = ''
        this.classes = []
      }
      if (item.params.section) {
        this.selectedSectionID = ''
        this.sections = []
      }
      if (item && item.params.feeTypeID) {
        this.selectedfeeTypeID = ''
        this.feeTypeList = []
        await this.getFeeTypes()
      }
      if (item.params.isExistingStudent) {
        this.selectedisExistingStudent = false
      }
      if (item.params.isActive) {
        this.selectedisActive = false
      }
      if (item.params.Offlinepaymentstatus) {
        this.selectedOfflineStatus = false
      }
      this.dialog = true

      this.applyFilter = item
      this.dialogLoader = false
    },
    // getClassList: async function (franchiseeID, filterBy) {
    //   try {
    //     this.classWiseSections = []
    //     this.classes = []
    //     if (franchiseeID.length > 1) {
    //       this.applyFilter.params.class = false
    //       this.applyFilter.params.section = false
    //     }
    //     if (franchiseeID.length === 0) {
    //       this.selectedClassID = ''
    //       this.selectedSectionID = ''

    //       return this.$dialog.error({
    //         text: ` select atleast one Franchisee`,
    //         title: 'Error'
    //       })
    //     }
    //     if (franchiseeID.length === 1) {
    //       if (this.copyArray.params.class) {
    //         this.applyFilter.params.class = true
    //       }
    //       if (this.copyArray.params.section) {
    //         this.applyFilter.params.section = true
    //       }
    //     }

    //     this.isLoading = true

    //     let para = {
    //       franchiseeID: franchiseeID[0].id,

    //       isAllValue: true
    //     }
    //     if (this.academicYearID) {
    //       para.academicYearID = this.academicYearID
    //     }
    //     let response = await http.get(`${constants.API_URL}/api/student/all-count`, { params: para })

    //     const data = response.data
    //     this.classes = data

    //     this.sections = data.map((obj) => {
    //       return {
    //         id: obj.id,
    //         sections: obj.studentSections
    //       }
    //     })
    //   } catch (e) {
    //     this.isLoading = false
    //     const errorMessage = (e && e.response && e.response.data.message) || e.message
    //     console.log('errorMessage', errorMessage)
    //     return this.$dialog.error({
    //       text: ` ${errorMessage}`,
    //       title: 'Error'
    //     })
    //   } finally {
    //     this.isLoading = false
    //   }
    // },
    getClassList: async function (franchiseeID, filterBy) {
      try {
        this.classWiseSections = []
        this.classes = []
        if (franchiseeID.length > 1) {
          this.applyFilter.params.class = false
          this.applyFilter.params.section = false
        }
        if (franchiseeID.length === 0) {
          this.selectedClassID = ''
          this.selectedSectionID = ''

          return this.$dialog.error({
            text: ` select atleast one Franchisee`,
            title: 'Error'
          })
        }
        if (franchiseeID.length === 1) {
          if (this.copyArray.params.class) {
            this.applyFilter.params.class = true
          }
          if (this.copyArray.params.section) {
            this.applyFilter.params.section = true
          }
        }

        this.isLoading = true
        let response = await http.get(
          `${constants.API_URL}/api/student/class-section?isRequired=false`
        )
        const data = response.data
        this.classes = data

        this.sections = data.map((obj) => {
          return {
            id: obj.id,
            sections: obj.studentSections
          }
        })
      } catch (e) {
        this.isLoading = false
        const errorMessage =
          (e && e.response && e.response.data.message) || e.message
        console.log('errorMessage', errorMessage)
        return this.$dialog.error({
          text: ` ${errorMessage}`,
          title: 'Error'
        })
      } finally {
        this.isLoading = false
      }
    },

    getselectedZonesList: function (zoneId, filterBy) {
      if (zoneId.length === 0) {
        return this.$dialog.error({
          text: ` select atleast one Zone`,
          title: 'Error'
        })
      }
    },

    getAcademicYear: async function () {
      try {
        this.dialogLoader = true
        const response = await http.get(
          `${constants.API_URL}/api/franchiseeAcademicYears`
        )
        const data = response.data
        this.academicYears = data.rows
      } catch (e) {
        const errorMessage =
          (e && e.response && e.response.data.message) || e.message
        console.log('Error While fetching Franchisee', errorMessage)
        return this.$dialog.error({
          text: ` ${errorMessage}`,
          title: 'Error'
        })
      } finally {
        this.dialogLoader = false
      }
    },

    getZoneDetails: async function () {
      try {
        this.dialogLoader = true
        let response = await http.get(
          `${constants.API_URL}/api/curriculum_cms/get-zones`
        )
        this.zones = response.data
      } catch (e) {
        const errorMessage =
          (e && e.response && e.response.data.message) || e.message
        console.log('Error While fetching zones', errorMessage)
        return this.$dialog.error({
          text: ` ${errorMessage}`,
          title: 'Error'
        })
      } finally {
        this.dialogLoader = false
      }
    },

    allZones: function () {
      let zoneArray = []
      if (this.zoneflag === true) {
        this.zones.forEach((Obj) => {
          zoneArray.push(Obj)
        })

        this.zoneflag = true
      }

      this.selectedZoneID = this.selectedZoneID =
      zoneArray
    },

    allFranchisee: function () {
      let franchiseeArray = []
      if (this.flag === true) {
        this.applyFilter.params.class = false
        this.applyFilter.params.section = false
        this.franchiseeArr.forEach((Obj) => {
          franchiseeArray.push(Obj)
        })

        this.flag = true
      } else {
        if (franchiseeArray.length === 0) {
          if (this.copyArray.params.class) {
            this.applyFilter.params.class = true
          }
          if (this.copyArray.params.section) {
            this.applyFilter.params.section = true
          }
        }
      }
      this.selectedFranchiseeID = this.selectedNullFranchiseeID =
        franchiseeArray
    },
    allFeeType: function () {
      let feeTypeArray = []
      if (this.feeTypeFlag === true) {
        this.feeTypeList.forEach((Obj) => {
          feeTypeArray.push(Obj)
        })

        this.feeTypeFlag = true
      }
      this.selectedfeeTypeID = feeTypeArray
    },
    getFranchiseeList: async function () {
      try {
        this.dialogLoader = true

        const { data } = await http.get(
          `${constants.API_URL}/api/franchisee/get/all`
        )
        this.franchiseeArr = data
      } catch (e) {
        this.dialogLoader = false

        const errorMessage =
          (e && e.response && e.response.data.message) || e.message
        return this.$buefy.dialog.alert({
          type: 'is-danger',
          message: errorMessage,
          hasIcon: true,
          animation: 'zoom-out',
          size: 'is-medium',

          icon: ' mdi-exclamation',
          iconPack: 'mdi',
          ariaRole: 'alertdialog',
          ariaModal: true
        })
      } finally {
        this.dialogLoader = false
      }
    },
    getFranchiseeList1: async function () {
      try {
        this.dialogLoader = true

        const { data } = await http.get(
          `${constants.API_URL}/api/franchisee/get/all`
        )
        this.franchiseeArr1 = data
        // this.franchiseeArr1 = [{ id: 0, companyName: 'Null' }, ...this.franchiseeArr1]
      } catch (e) {
        this.dialogLoader = false

        const errorMessage =
          (e && e.response && e.response.data.message) || e.message
        return this.$buefy.dialog.alert({
          type: 'is-danger',
          message: errorMessage,
          hasIcon: true,
          animation: 'zoom-out',
          size: 'is-medium',

          icon: ' mdi-exclamation',
          iconPack: 'mdi',
          ariaRole: 'alertdialog',
          ariaModal: true
        })
      } finally {
        this.dialogLoader = false
      }
    },

    getFeeTypes: async function () {
      try {
        this.isLoading = true
        const response = await http.get(`${constants.API_URL}/api/fee-type`)
        this.feeTypeList = response.data.rows
        this.feeTypeList.push({ id: 0, name: 'Application Form' })
      } catch (e) {
        const errorMessage =
          (e && e.response && e.response.data.message) || e.message
        return this.$dialog.error({
          text: ` ${errorMessage}`,
          title: 'Error'
        })
      } finally {
        this.isLoading = false
      }
    },

    changeSections: async function () {
      try {
        this.isLoading = true
        let sectionarray = this.sections.find(
          (obj) => obj.id === this.selectedClassID
        )
        if (sectionarray) {
          this.classWiseSections = sectionarray.sections
        } else {
          this.classWiseSections = []
        }
      } catch (e) {
        const errorMessage =
          (e && e.response && e.response.data.message) || e.message
        return this.$dialog.error({
          text: ` ${errorMessage}`,
          title: 'Error'
        })
      } finally {
        this.isLoading = false
      }
    },
    getSourceType: async function () {
      try {
        this.dialogLoader = true
        const { data: questions1 } = await http.get(
          `${constants.API_URL}/api/enquiry-questions`
        )
        this.sourcetype = questions1.filter(
          (obj) => obj.type === 'SOURCE_OF_CONTACT'
        )
        console.log('Sources', this.sourcetype)
      } catch (e) {
        const errorMessage =
          (e && e.response && e.response.data.message) || e.message
        console.log('Error While fetching Sourcetype', errorMessage)
        return this.$dialog.error({
          text: ` ${errorMessage}`,
          title: 'Error'
        })
      } finally {
        this.dialogLoader = false
      }
    },
    filterBySpanco: async function () {
      try {
        this.isLoading = true
        let { data } = await http.get(
          `${constants.API_URL}/api/getEnquiryStages`
        )
        this.spancoArray = _.map(data, function (x) {
          let name = x.name + ' - ' + x.statusName
          let spancoItem = {}
          spancoItem.id = x.id
          spancoItem.name = name
          return spancoItem
        })
      } catch (e) {
        const errorMessage =
          (e && e.response && e.response.data.message) || e.message
        this.$dialog.error({
          text: errorMessage,
          title: 'Error'
        })
      } finally {
        this.isLoading = false
      }
    },
    getSourceTypeForEnquirySource: async function () {
      try {
        this.dialogLoader = true
        const result = await http.get(`${constants.API_URL}/api/enquirySources`)
        // this.sourceTypeEnquirySource = data
        this.sourceTypeEnquirySource = _.map(result.data, function (x) {
          let name = x.source
          let item = {}
          item.name = name || '-'
          return item
        })
        console.log('Sources', this.sourceTypeEnquirySource)
      } catch (e) {
        const errorMessage =
          (e && e.response && e.response.data.message) || e.message
        console.log(
          'Error While fetching sourceTypeEnquirySource',
          errorMessage
        )
        return this.$dialog.error({
          text: ` ${errorMessage}`,
          title: 'Error'
        })
      } finally {
        this.dialogLoader = false
      }
    },
    close () {
      this.applyFilter.params = this.copyArray.params
      this.dialog = false
      this.feeTypeFlag = false
      return this.applyFilter
    },
    onFranchiseeChange: async function () {
      if (!this.inProgress) {
        this.inProgress = true
        // if (this.academicYear) {
        //   this.academicYearID = this.academicYear.id
        // } else {
        //   this.academicYearID = ''
        // }
        if (this.franchisee) {
          this.franchiseeID = this.franchisee.id
          if (this.franchiseeID) {
            await this.getFranchisee()
          }
        } else {
          this.franchiseeID = ''
        }
        this.inProgress = false
      }
    },
    getFranchisee: async function () {
      try {
        this.franArray = []
        this.isLoading = true
        let res = await http.get(`${constants.API_URL}/api/franchisee/${this.franchiseeID}`)
        // this.franchiseeArr = res.data
        this.franArray.push(res.data)
      } catch (e) {
        const errorMessage = (e && e.response && e.response.data.message) || e.message
        this.errMsg(errorMessage)
      } finally {
        this.isLoading = false
      }
    },
    checkFranchisee: async function () {
      if (_.isEmpty(this.franArray)) {
        return this.$dialog.error({
          text: `Please select Franchisee from the right side Hamburger Menu!`,
          title: 'Error'
        })
      }
    },
    paramsFilter: async function () {
      // if (stores.user.me.superAdmin === false) {
      //   for (const item of stores.user.roles) {
      //     if (item.role === 'FRANCHISEE_USER_1' || item.role === 'CH_LEVEL1' || item.role === 'CH_LEVEL2' || item.role === 'CH_LEVEL3') {
      //       this.zonesParam = false
      //       this.kitIndentOrders = true
      //     } else if (item.role === 'SUPER_ADMIN') {
      //       this.zonesParam = true
      //     } else if (item.role === 'BUSINESS_DEVELOPER') {
      //       this.kitIndentOrders = true
      //       this.zonesParam = true
      //     }
      //   }
      // } else {
      //   this.zonesParam = true
      // }

      if (stores.user.me.superAdmin === true) {
        this.kitIndentOrders = true
        this.zonesParam = true
      } else {
        this.zonesParam = true
      }
    }
  }
}
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
